import { render, staticRenderFns } from "./LxCurrencyInput.vue?vue&type=template&id=459289f0"
import script from "./LxCurrencyInput.vue?vue&type=script&lang=js"
export * from "./LxCurrencyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports